var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.788,
    height: 30.863,
    viewBox: "0 0 25.788 30.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-marker-svgrepo-com",
    transform: "translate(-4.25 -2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32055",
    "data-name": "Path 32055",
    d: "M17.144,33.563a1.149,1.149,0,0,1-.682-.216c-.5-.316-12.212-8.186-12.212-17.752a12.894,12.894,0,1,1,25.788,0c0,9.567-11.646,17.436-12.212,17.752A1.149,1.149,0,0,1,17.144,33.563Zm0-28.284a10.365,10.365,0,0,0-10.4,10.315c0,7,7.969,13.41,10.4,15.19,2.429-1.78,10.4-8.186,10.4-15.19a10.365,10.365,0,0,0-10.4-10.315Z",
    transform: "translate(0 0)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32056",
    "data-name": "Path 32056",
    d: "M13.825,16.4a4.576,4.576,0,1,1,3.235-1.34A4.575,4.575,0,0,1,13.825,16.4Zm0-6.655a2.08,2.08,0,1,0,1.471.609A2.08,2.08,0,0,0,13.825,9.746Z",
    transform: "translate(3.319 3.02)",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcMap);
export default __webpack_public_path__ + "static/media/vc-map.b8a010b58303c76a371c91231d771c7a.svg";
export { ForwardRef as ReactComponent };